module.exports = __webpack_public_path__ + "fonts/notonaskharabicui-regular-webfont.df2fcaa2.woff";